import styles from './index.less';

import {

    Typography,
    Divider,
    Space,
    Tooltip,
} from 'antd';
import { QuestionCircleTwoTone } from '@ant-design/icons';
import { pageMarginTrade } from '@/services/bMerchant ';
import ProTable from '@ant-design/pro-table';
const DepositRecords = (props) => {
    const { tenantId } = props;
    const columns = [
        {
            title: '操作时间',
            // valueType: 'dateTime',
            key: 'operateTime',
            dataIndex: 'operateTime',
        },

        {
            title: '保证金事件',
            key: 'fundType',
            dataIndex: 'fundType',
        },
        {
            title: '金额',
            key: 'amount',
            dataIndex: 'amount',
            render: (_, record) => {
                const { amount, remark, bizType, fundType } = record;
                return (
                    <Space>
                        {amount}
                        {remark && (
                            <Tooltip
                                title={
                                    <div>
                                        <div>{`标记类型：${fundType}`}</div>
                                        <div>{`扣罚事件：${bizType}`}</div>
                                        <div>
                                            备注说明：
                                            <span className={styles.breakAll}>{remark}</span>
                                        </div>
                                    </div>
                                }
                            >
                                <QuestionCircleTwoTone />
                            </Tooltip>
                        )}
                    </Space>
                );
            },
        },
        {
            title: '操作人',
            dataIndex: 'operator',
        },
        {
            title: '对应订单编号',
            key: 'orderNo',
            dataIndex: 'orderNo',
            render: (text, record, index, action) => {
                if (record.orderNo) {
                    return (
                        <Typography.Link
                            underline
                            onClick={() => {
                                window.open(
                                    `/operating/order?orderNo=${record.orderNo}`,
                                    '_blank',
                                );
                            }}
                        >
                            {text}
                        </Typography.Link>
                    );
                }
                return text;
            },
        },
        {
            title: '订单状态',
            key: 'orderStatus',
            dataIndex: 'orderStatus',
        },
        {
            title: '订单实付金额',
            key: 'orderPaidAmount',
            dataIndex: 'orderPaidAmount',
        }
    ];

    return (
        <div>
            <div className={`${styles.wrap} ${styles.headRow}`}>
                <Typography.Title level={5} className={styles.titleFlush}>
                    保证金详情
                </Typography.Title>
            </div>
            <Divider className={styles.dividerGap} />

            <ProTable
                columns={columns}
                request={async (params) => {
                    const { data, page, code } = await pageMarginTrade({
                        requestData: { ...params, tenantId },
                        page: {
                            currentPage: params.current,
                            pageSize: params.pageSize,
                        },
                    });
                    if (code !== '00000') {
                        return {
                            success: false,
                        };
                    }
                    return {
                        data: data.tradeList,
                        success: true,
                        total: page.count,
                    };
                }}
                toolbar={null}
                toolBarRender={false}
                scroll={{ x: 'max-content' }}
                rowKey={'id'}
                search={false}
                pagination={{
                    defaultPageSize: 10,
                }}
                dateFormatter="string"
            />
        </div>
    );
};

export default DepositRecords;
